import { Component, Directive, ElementRef, Injector, ChangeDetectionStrategy } from "@angular/core";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'pending-sections-directive',
    standalone: false,
})
export class PendingSectionsDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('pendingSections', elementRef, injector);
        console.log("PendingSectionsDirective initialized");
    }
}

@Component({
    selector: 'pending-sections',
    template: '<pending-sections-directive></pending-sections-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PendingSectionsComponent {
    constructor() {
        console.log("PendingSectionsComponent initialized");
    }
}
